<template>
    <div style="margin: 0px; padding: 0px;">
        <span style="width: 200px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
            支付宝登录页面跳转中。。。。。。
        </span>
        <div v-html="sHtmlText"></div>
    </div>
</template>
<script>
// import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            sHtmlText:'',
        }
    },
    mounted(){
        this.getDate();
    },
    methods:{
        getDate(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/login/alipayauth.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code){
                    that.sHtmlText = res.data.sHtmlText;
                    setTimeout(function() {
                         document.forms['alipaysubmit'].submit();
                    },100)
                }
            })
        },
    },
    // watch:{
    //     sHtmlText:function(newVal, oldVal){
    //         //console.log("oldVal:" + oldVal);
    //         if(newVal && newVal !=''){
    //             console.log(newVal);
    //             document.forms['alipaysubmit'].submit();
    //         }
            
            
    //     }
    // }
}
</script>



// WEBPACK FOOTER //
// src/components/alipaylogin/alipayauth.vue